export default {
  redShadow: '10px 10px 20px rgba(237, 52, 56, 0.3);',
};
